export default __webpack_public_path__ + "static/media/Restore.d988138b.svg";